// Shared ReactPlayer config.
// Provides a safe HLS logger that won't crash if browser extensions
// (anti-fingerprinting, ad blockers) nullify console methods.
const safeLogger = {
  trace: () => {},
  debug: () => {},
  log: () => {},
  warn: () => {},
  info: () => {},
  error: () => {},
}

const reactPlayerConfig = {
  file: {
    hlsOptions: {
      enableWorker: true,
      debug: safeLogger,
    },
  },
}

export default reactPlayerConfig
